let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b7mki")).then(() => parcelRequire('8NrV4'));